module.exports = __webpack_public_path__ + "img/trash.70595634.svg";